import { useState } from "react";
import { TextField, FormControl } from "@mui/material";
import { useFormik } from "formik";
import Yup from "validation/Validation";
import { useResponseErrorOnly } from "hooks";
import { CategoriesSelect, GridFilter } from "components";
import { useGetCategoriesQuery } from "redux/api/slices/server";

const SearchBar = ({ Arama, data, id }) => {
  const [urunKategori, setUrunKategori] = useState(0);
  const categories = useGetCategoriesQuery();

  const handleOnChange = (e) => {
    setUrunKategori(e.target.value);
  };

  const formFields = {
    kategori: Yup.string(),
  };

  const validationSchema = Yup.object(formFields);
  const formikConfig = {
    initialValues: {
      kategori: "",
      urunKategori: urunKategori,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      resetForm();
      Arama({
        tr_baslik: values.kategori,
        ust_id: parseInt(urunKategori),
      });
    },
  };

  const { handleSubmit, handleChange, values, errors, resetForm } =
    useFormik(formikConfig);

  useResponseErrorOnly(data);

  return (
    <GridFilter
      data={data}
      newItemUrl={`/detail-product/0/${id}`}
      handleSubmit={handleSubmit}
      title={"Kategori Arama"}
    >
      <div className="grid grid-cols-2 gap-3 mb-4">
        <FormControl fullWidth sx={{ m: 0 }}>
          <TextField
            sx={{ m: 0 }}
            size="small"
            margin="normal"
            required
            fullWidth
            id="kategori"
            label="Kategori Adı"
            name="kategori"
            autoComplete="kategori"
            onChange={handleChange}
            values={values.kategori}
            helperText={errors.kategori && errors.kategori}
            error={errors.kategori ? true : false}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 0 }}>
          <CategoriesSelect
            data={categories}
            urunKategori={urunKategori}
            handleOnChange={handleOnChange}
            defaultTitle="Üst Kategori Seçin"
          />
        </FormControl>
      </div>
    </GridFilter>
  );
};

export default SearchBar;
